import $ from 'jquery';

// bootstrap needs these globally available because it sucks. You also
// can't use 'import' for bootstrap or it dies
global.$ = $;
global.jQuery = $;
require('bootstrap');
require('jquery-ujs');
